import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { MatExpansionPanel } from '@angular/material/expansion';
import { Globals } from 'src/app/globals';

@Component({
  selector: 'app-generic-iq-analysis-summary-accordin',
  templateUrl: './generic-iq-analysis-summary-accordin.component.html',
  styleUrl: './generic-iq-analysis-summary-accordin.component.sass',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class GenericIqAnalysisSummaryAccordinComponent {
  @ViewChild('accordinPanel') accorinPanel!: MatExpansionPanel;
  items = [1, 2, 3, 4, 5, 6];
  expandedItems: boolean[] = [];
  iconName: string = '';
  @Input() type: string = '';
  @Input() itemsData: any;
  @Output() itemDeclined = new EventEmitter<any>();
  private declinedItemsBackup: any[] = [];
  
  constructor(public globals: Globals, private cdRef: ChangeDetectorRef) {}

  ngOnInit(): void {
    this.iconName = this.type === 'issues' ? 'uil-puzzle-piece' : this.type === 'stakeholders' ? 'uil-users-alt' : this.type === 'context_items' ? 'uil-link' : this.type === 'Contact persons' ? 'uil-user-square' : '';
    this.expandedItems = this.itemsData.map(() => false);
    this.itemsData = this.itemsData.map(i => ({
      ...i,
      status: null
    }));
  }

  toggleItem(index: number) {
    this.expandedItems[index] = !this.expandedItems[index];
  }

  updateItemStatus(index: number, status: 'accepted' | 'declined') {
    const item = this.itemsData[index];
    if (status === 'accepted') {
      item.status = 'accepted';
    } else if (status === 'declined') {
      // item.status = 'declined';
      this.itemsData.splice(index, 1);
      this.expandedItems.splice(index, 1);
      this.declinedItemsBackup.push(item);
      // if (this.type === 'context_items') {
      //   this.itemDeclined.emit(item);
      // }
    }
    this.cdRef.markForCheck();
  }

  updateAllItemsStatus(status: 'accepted' | 'declined') {
    if (status === 'accepted') {
      this.itemsData = [...this.itemsData, ...this.declinedItemsBackup];
      this.declinedItemsBackup = [];
      this.itemsData = this.itemsData.map(item => ({ ...item, status: 'accepted' }));
      this.expandedItems = this.itemsData.map(() => false);
    } else if (status === 'declined') {
      const allItems = [...this.itemsData, ...this.declinedItemsBackup];
      this.declinedItemsBackup = allItems;
      this.itemsData = [];
      this.expandedItems = [];
      // if (this.type === 'context_items') {
      //   allItems.forEach(item => this.itemDeclined.emit(item));
      // }
      if (this.accorinPanel) this.accorinPanel.close();
    }
    this.cdRef.detectChanges();
  }

  allItemsDealtWith(): boolean {
    const allItems = [...this.itemsData, ...this.declinedItemsBackup];
    if (allItems.length === 0) return false;
    return allItems.every(item => item.status === 'accepted' || this.declinedItemsBackup.includes(item));
  }

  getBadgeClass(): string {
    const allItems = [...this.itemsData, ...this.declinedItemsBackup];
    if (!allItems.length) {
      return this.accorinPanel?.disabled ? 'badge-disabled' : 'badge-pending';
    }
    if (this.allItemsDealtWith()) {
      const allDeclined = allItems.every(item => item.status === 'declined');
      if (allDeclined && this.accorinPanel?.disabled) {
        return 'badge-disabled';
      }
      return 'badge-dealt';
    }
    return 'badge-pending';
  }

  removeItemsByIds(ids: number[]) {
    this.itemsData = this.itemsData.filter(item => !ids?.includes(item.id));
    this.expandedItems = this.itemsData.map(() => false);
    this.cdRef.markForCheck();
  }

  restoreItems(items: any[]) {
    this.itemsData = [...this.itemsData, ...items];
    this.expandedItems = this.itemsData.map(() => false);
    this.cdRef.markForCheck();
  }

  formatText(rawText: string): string {
    if (!rawText) return '';

    const replaced = rawText.replace(/[_-]/g, ' ');
    return replaced.charAt(0).toUpperCase() + replaced.slice(1);
  }
}
